import { useEffect, useState } from "react";
import { useNavigationContext } from "../context/NavigationContext";
import { hasChangedComparedToModified } from "../utils/configChecksum/configComparer";
import { debounce } from "../commonFunctions/arrayFunc";

function useUnsavedChangesGuard() {
  const { getCurrentPageData, getCurrentPageConfigFunction } = useNavigationContext();
  const page = getCurrentPageData();
  const [isChange, setIsChange] = useState(false);
  const changeDepedencies = async () => {
    try {
      const newConfig = await getCurrentPageConfigFunction(page.page);
      const hasConfigChange = hasChangedComparedToModified(newConfig);
      setIsChange(hasConfigChange);
    } catch (error) {
      console.log("Something went wrong", error);
    }
  };

  const onChangeStatus = (newStatus) => {
    setIsChange(newStatus);
  };

  const DEBOUNCE_DELAY = 300;
  useEffect(() => {
    const debouncedFn = debounce(() => {
      changeDepedencies();
    }, DEBOUNCE_DELAY);

    debouncedFn();

    return () => {
      debouncedFn.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page.stateList]);

  return { isChange, onChangeStatus };
}

export default useUnsavedChangesGuard;
